export default __webpack_public_path__ + "static/media/p24.67c39123.jpg";